import { render, staticRenderFns } from "./OrderDifferentsPopup.vue?vue&type=template&id=45206336&scoped=true&"
import script from "./OrderDifferentsPopup.vue?vue&type=script&lang=js&"
export * from "./OrderDifferentsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45206336",
  null
  
)

export default component.exports